/**
 * Core Store Locator Page
 * Fallback page for store locator functionality
 */

import React from 'react';
import StoreLocator from '../components/StoreLocator.jsx';

export function StoreLocatorPage() {
  return (
    <div className="store-locator-page">
      <StoreLocator />
    </div>
  );
}

export default StoreLocatorPage;
